<template>
    <v-container fluid style="display: flex; flex-direction: column;" >
        <v-row>
            <v-col cols="12" class="borda">
                <h2 class="">Aulas</h2>
            </v-col>
        </v-row>
        
        <v-list class="lista">
            <v-list-group  :value="true" v-for="mod in curso.modulos" :key="mod.id">
                <template v-slot:activator>
                    <v-list-item-title ><h2>{{mod.nome}}</h2></v-list-item-title>
                </template>
                <v-list-item sub-group v-for="aula in mod.aulas" :key="aula.id">
                    <v-list-item-content class="py-0 maozinha" @click="abrirContent(aula)">
                        <v-list-item-title >
                            <v-toolbar flat dense class="ma-0 pa-0 lista" >
                                <v-icon class="mr-3">mdi-video</v-icon>
                                <v-toolbar-title>{{aula.nome}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-checkbox dense class="mt-5" readonly v-model="aula.concluida"></v-checkbox>
                            </v-toolbar>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-container>    
</template>

<script>
    export default{
        props: ['curso'],
        methods: {
            abrirContent(registro){
                this.$emit('abrirAula', registro)
            },
        }
    }
</script>

<style scoped>
.conteudoMenu{
    height: calc(100vh - 84px);
    overflow-y: auto;
    background-color: rgba(220, 220, 255, 0.8); 
    border-radius: 6px;
    margin: 0 8px;
}

.lista{
    background-color: transparent !important;
}

.maozinha{
    cursor: pointer;
}

.modulo{
    background-color: rgba(200, 200, 255, 1);
}

.borda{
    border-bottom: 1px solid rgba(220, 220, 255, 1);
}

@media only screen and (max-width: 1200px){
    .conteudoMenu{
        height: calc(100vh - 284px);
        /* background-color: rgba(220, 220, 255, 0.8); */
        background-color: yellow;
        border-radius: 6px;
    }
}
</style>